import { format } from 'date-fns';

export const formatDate = (date: Date | string | number | undefined | null) =>
  date ? format(new Date(date), 'dd/MM/yyyy à HH:mm') : '';
